import { removeAuthToken } from "./token";

export const toLogin = (query?: string): void => {
  localStorage.removeItem("2fa")
  removeAuthToken()
  window.location.href = query ? `/login?${query}` : '/login';
} 